import React, { lazy } from 'react';
import Tool from '../../shared/components/Tool';
import {
	MUTATION_DELETE_OC_CASE,
	MUTATION_UPDATE_OC_CASE,
} from '../../shared/gql/mutations';
import {
	QUERY_GET_ALL_OC_CASES,
	QUERY_GET_OC_CASE,
} from '../../shared/gql/queries';
import CaseProvider from '../../shared/providers/CaseProvider';

const OperatingCostCase = lazy(() => import('./OperatingCostCase'));
const OperatingCost = () => (
	<CaseProvider caseMutation={MUTATION_UPDATE_OC_CASE}>
		<Tool
			caseQuery={QUERY_GET_OC_CASE}
			allCasesQuery={QUERY_GET_ALL_OC_CASES}
			deleteMutation={MUTATION_DELETE_OC_CASE}
			partitionKey='E'
		>
			<OperatingCostCase />
		</Tool>
	</CaseProvider>
);

export default OperatingCost;
